export const TOTALACESSOS = 'TOTALACESSOS';
export const TOTALACESSOS_START = 'TOTALACESSOS_START';
export const TOTALACESSOS_SUCCESS = 'TOTALACESSOS_SUCCESS';
export const TOTALACESSOS_ERROR = 'TOTALACESSOS_ERROR';
